import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { effects } from './effects'

@NgModule({
  imports: [
    StoreModule,
    EffectsModule.forFeature(effects),
  ]
})
export class MbUserStoreModule {
}
